export default __webpack_public_path__ + "static/media/List-documentation.65c28e1d.md";